import { apiRequest } from './api.js';
import API_CONFIG from './api.js';

// Admin related API calls
export const adminService = {  // Check if user has admin access
  checkAdminAccess: async (token) => {
    const url = `${API_CONFIG.BACKEND_URL}/admin/check-admin-access`;
    
    try {
      return await apiRequest(url, {
        method: 'GET',
        token
      });
    } catch (error) {
      // Handle timeout errors specifically
      if (error.message.includes('timeout') || error.message.includes('Request timeout')) {
        console.warn('Admin access check request timed out after 90 seconds');
        throw new Error('Admin access check timeout exceeded (90 seconds). Please check your connection and try again.');
      }
      throw error;
    }
  },
  // Get all users with optional search and role filters
  getUsers: async (searchQuery = '', roleFilter = '', token) => {
    const queryParams = new URLSearchParams();
    if (searchQuery) queryParams.append('search', searchQuery);
    if (roleFilter) queryParams.append('role', roleFilter);
    
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const url = `${API_CONFIG.BACKEND_URL}/admin/users${queryString}`;
    
    try {
      return await apiRequest(url, {
        method: 'GET',
        token
      });
    } catch (error) {
      // Handle timeout errors specifically
      if (error.message.includes('timeout') || error.message.includes('Request timeout')) {
        console.warn('Get users request timed out after 90 seconds');
        throw new Error('Get users timeout exceeded (90 seconds). Please check your connection and try again.');
      }
      throw error;
    }
  },
  // Create a new user
  createUser: async (userData, token) => {
    const url = `${API_CONFIG.BACKEND_URL}/admin/users`;
    
    try {
      return await apiRequest(url, {
        method: 'POST',
        body: JSON.stringify(userData),
        token
      });
    } catch (error) {
      // Handle timeout errors specifically
      if (error.message.includes('timeout') || error.message.includes('Request timeout')) {
        console.warn('Create user request timed out after 90 seconds');
        throw new Error('Create user timeout exceeded (90 seconds). Please check your connection and try again.');
      }
      throw error;
    }
  },
  // Update an existing user
  updateUser: async (userId, userData, token) => {
    const url = `${API_CONFIG.BACKEND_URL}/admin/users/${userId}`;
    
    try {
      return await apiRequest(url, {
        method: 'PUT',
        body: JSON.stringify(userData),
        token
      });
    } catch (error) {
      // Handle timeout errors specifically
      if (error.message.includes('timeout') || error.message.includes('Request timeout')) {
        console.warn(`Update user ${userId} request timed out after 90 seconds`);
        throw new Error('Update user timeout exceeded (90 seconds). Please check your connection and try again.');
      }
      throw error;
    }
  },
  // Delete a user
  deleteUser: async (userId, token) => {
    const url = `${API_CONFIG.BACKEND_URL}/admin/users/${userId}`;
    
    try {
      return await apiRequest(url, {
        method: 'DELETE',
        token
      });
    } catch (error) {
      // Handle timeout errors specifically
      if (error.message.includes('timeout') || error.message.includes('Request timeout')) {
        console.warn(`Delete user ${userId} request timed out after 90 seconds`);
        throw new Error('Delete user timeout exceeded (90 seconds). Please check your connection and try again.');
      }
      throw error;
    }
  }
};

export default adminService;
